import React from 'react';
import { Grid, Card } from 'semantic-ui-react';
import { ExtendedDocuments } from '../Documents';
import FNButtons from './FNButtons';

const filterCourtDocuments = [
  'Documents::Undefined',
  'Documents::CaseLaw'
];

const CourtAttachments = ({
  navButtonsProps,
  ...rest
}) => (
  <React.Fragment>
    <Card.Description>
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <ExtendedDocuments
              editDisabled={false}
              documentsName="selectedCourtDocuments"
              filterTypes={filterCourtDocuments}
              disableCropping
              {...rest}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Description>
    <FNButtons {...navButtonsProps} />
  </React.Fragment>
);

export default CourtAttachments;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/CourtAttachments.js